/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import profile from './modules/profile.js'
import settings from './modules/settings.js'
import customers from "@/store/modules/customers";
import invoices from "@/store/modules/invoices";
import notifications from "@/store/modules/notifications";
import tasks from "@/store/modules/tasks";


Vue.use(Vuex)

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: [profile, settings, customers, invoices, notifications, tasks],
  strict: process.env.NODE_ENV !== 'production'
})
